// src/pages/Dashboard.tsx
import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, "") || "/api";

interface Country {
  id: number;
  name: string;
  created_at: string;
}

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const [countries, setCountries] = useState<Country[]>([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/countries`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include", // send the HTTP-only auth cookie
    })
      .then(res => {
        if (!res.ok) {
          throw new Error("Failed to fetch countries");
        }
        return res.json();
      })
      .then((data: Country[]) => {
        setCountries(data);
      })
      .catch(err => {
        console.error(err);
        // Optionally: redirect to /login if unauthorized
      });
  }, []);

  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Overall container style
  const containerStyle: React.CSSProperties = {
    backgroundColor: "#F0F5F0",
    minHeight: "100vh",
    padding: "20px",
  };

  // Card style for the Emerging Markets card
  const cardStyle: React.CSSProperties = {
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    maxWidth: "600px",
    margin: "50px auto",
    padding: "30px",
  };

  // Header bar style with the accent color (#e41e26)
  const headerBarStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    borderBottom: "2px solid #e41e26",
    paddingBottom: "10px",
  };

  const headerTitleStyle: React.CSSProperties = {
    fontSize: "24px",
    color: "#e41e26",
  };

  // Button style for the header button (now labeled "Edit")
  const buttonStyle: React.CSSProperties = {
    padding: "5px 10px",
    backgroundColor: "#e41e26",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  };

  // Table styling
  const tableStyle: React.CSSProperties = {
    width: "100%",
    borderCollapse: "collapse",
  };

  const thStyle: React.CSSProperties = {
    textAlign: "left",
    padding: "8px",
    borderBottom: "1px solid #ccc",
    color: "#e41e26",
  };

  const thRightAlignStyle: React.CSSProperties = {
    ...thStyle,
    textAlign: "right",
  };

  const tdStyle: React.CSSProperties = {
    padding: "8px",
    borderBottom: "1px solid #ccc",
    cursor: "pointer",
  };

  const tdDateStyle: React.CSSProperties = {
    ...tdStyle,
    textAlign: "right",
  };

  return (
    <div style={containerStyle}>
      <Navbar />
      <div style={cardStyle}>
        <div style={headerBarStyle}>
          <div style={headerTitleStyle}>Emerging Markets</div>
          <button style={buttonStyle} onClick={() => navigate("/edit-country")}>
            Edit
          </button>
        </div>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Country</th>
              <th style={thRightAlignStyle}>Added</th>
            </tr>
          </thead>
          <tbody>
            {countries.map(country => (
          
			<tr key={country.id}>
			  <td style={tdStyle}>
				<button
				  style={buttonStyle}
				  onClick={() => navigate(`/country/${country.id}`)}
				>
				  {country.name}
				</button>
			  </td>
			  <td style={tdDateStyle}>
				{formatDate(country.created_at)}
			  </td>
			</tr>

            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Dashboard;
